export const DIALOG_LABEL_WIDTH = "160px";
